import { Box, Stack, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

type Props = {
  language: string
  text: string
  keys: Array<string>
}

export const DuplicatesToastBody = ({ language, text, keys }: Props) => {
  const { t } = useTranslation()

  return (
    <Stack spacing={1} mt={1}>
      <Box display="flex" alignItems="center">
        <Typography variant="caption3" color="text.primary">
          {t('common.language')}:
        </Typography>
        <Typography variant="caption3" color="text.secondary" ml={1}>
          {language}
        </Typography>
      </Box>

      <Box display="flex" alignItems="center">
        <Typography variant="caption3" color="text.primary">
          {t('common.text')}:
        </Typography>
        <Typography variant="caption3" color="text.secondary" ml={1}>
          {text}
        </Typography>
      </Box>

      <Typography variant="caption3" color="text.primary">
        {t('common.keys')}:
      </Typography>
      {keys.map(key => (
        <Typography key={key} variant="caption3" color="text.secondary" pl={2}>
          - {key}
        </Typography>
      ))}
    </Stack>
  )
}
